export const SORT_CONFIG = [
  {
    sort: "metacritic",
    text: "Rating Lowest",
  },
  {
    sort: "-metacritic",
    text: "Rating Highest",
  },
  {
    sort: "-released",
    text: "Newest",
  },
  {
    sort: "released",
    text: "Oldest",
  },
];
